module.exports = __webpack_public_path__ + "static/media/33_B.fa9d4b3f.png";